import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

import { FeaturedPeopleFilters } from '../types';

export const useFeaturedPeopleFilters = createTableFiltersState<FeaturedPeopleFilters>({
  tableKey: TableKeyEnum.FEATURED_PEOPLE,
});
